import { LANDING_CODE_QUERY_KEY } from '@/constants/landing-dye';

/** 染色 / register / LandingApi：URL 上优先 landing_code，兼容旧链 promotion_code */
export function resolvePromotionCodeForDye(search: Pick<URLSearchParams, 'get'>): string | null {
    const landingCode = search.get(LANDING_CODE_QUERY_KEY)?.trim();
    if (landingCode) {
        return landingCode;
    }
    const promotionCode = search.get('promotion_code')?.trim();
    return promotionCode || null;
}

export function hasLandingDyeAttribution(search: Pick<URLSearchParams, 'get'>): boolean {
    const promotion_code = resolvePromotionCodeForDye(search);
    const track_id = search.get('track_id')?.trim();
    const ad_id = search.get('ad_id')?.trim();
    const adset_id = search.get('adset_id')?.trim();
    return Boolean(promotion_code && track_id && ad_id && adset_id);
}
